import {CdkTreeModule} from '@angular/cdk/tree';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatIconModule} from '@angular/material/icon';
import {MatTreeModule} from '@angular/material/tree';
import {ReasonCodesComponent} from './reason-codes.component';

@NgModule({
  imports: [CommonModule, MatTreeModule, CdkTreeModule, MatIconModule, MatCheckboxModule],
  exports: [ReasonCodesComponent],
  declarations: [ReasonCodesComponent]
})
export class ReasonCodesModule {}
